// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2417":"fc34d772","32095":"ce0dd5ce","52761":"cf40cd47","56238":"b38ce23f"}[chunkId] + ".css";
};